import { useAuthContext } from '../../../contexts/AuthContext'
import { faCommentSms } from '@fortawesome/free-solid-svg-icons'
import { TestSendForm, TestPageHeader } from '../../../components/alerts/TestSendForm'
import { alertsApi } from '../../../services/admin/alertsApi'
import { LocalStorageItem } from '../../../common/constants'

const PHONE_REGEX = /^\+?[1-9]\d{1,14}$/

export default function DirectSmsTestPage() {
  const { email } = useAuthContext()
  return (
    <div className="space-y-6">
      <TestPageHeader
        mode="direct"
        title="Direct SMS"
        subtitle={
          <>
            Bypasses the alerts pipeline. Calls Twilio directly. Counts against your daily test-SMS
            quota. Phone numbers must be in E.164 format (e.g.{' '}
            <span className="font-medium text-gray-700">+12403764102</span>).
          </>
        }
      />

      <section className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <TestSendForm
          mode="direct"
          recipientLabel="Recipient phone"
          recipientType="tel"
          recipientPlaceholder="+12403764102"
          recipientRegex={PHONE_REGEX}
          recipientInvalidMessage="Enter a valid E.164 phone number (digits only, optional leading +)."
          bodyRows={3}
          defaultBody={`AtCreate direct test SMS from the admin portal${email ? ` (by ${email})` : ''}.`}
          storageKey={LocalStorageItem.adminTestSmsRecipient}
          buttonLabel="Send Test SMS"
          buttonIcon={faCommentSms}
          bodyHelper="Long messages may be split into multiple Twilio segments."
          onSend={async (params) => {
            const r = await alertsApi.directSms(params)
            return { recipient: r.recipient }
          }}
        />
      </section>
    </div>
  )
}
